const menuStyles = {
  menu: (baseStyles) => {
    return {
      ...baseStyles,
      boxShadow: 'none',
      border: 'none',
      borderRadius: '10px',
      padding: '0 4px',
      backgroundColor: 'transparent',
    }
  },
  menuList: (baseStyles) => {
    return {
      ...baseStyles,
      background: '#fff',
      padding: '1px',
      borderRadius: '10px',
      boxShadow: `rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px`,
      transition: `box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
    }
  },
}

const darkColor = '#1B1F24'
const lightColor = '#fff'
const errorColor = '#ef4444'

export default function getDropdownStyles(light, isError) {
  const borderColor = isError ? errorColor : light ? lightColor : darkColor
  const textColor = light ? lightColor : darkColor

  const color = light ? lightColor : darkColor

  return {
    ...menuStyles,
    option: (provided, state) => {
      const index = state?.data?.index
      const isFirst = index === 0
      const isLast = index === state?.options?.length - 1

      return {
        ...provided,
        fontSize: '1rem',
        cursor: 'pointer',
        backgroundColor: state.isSelected
          ? '#5F8193'
          : state.isFocused
            ? 'rgba(0,0,0,0.08)'
            : 'transparent',
        color: state.isSelected ? '#fff' : '#313539',
        padding: '6px 16px',
        borderRadius: isFirst ? '9px 9px 0 0' : isLast ? '0 0 9px 9px' : '0',
        textTransform: 'uppercase',
      }
    },
    placeholder: (provided) => {
      return { ...provided, fontSize: '1rem', textTransform: 'uppercase', color: '#1B1F24' }
    },
    control: (baseStyles) => {
      return {
        ...baseStyles,
        boxShadow: 'none',
        cursor: 'pointer',
        padding: '10px 30px',
        borderRadius: '37px',
        borderWidth: 1,
        borderColor: borderColor,
        background: 'transparent',
        color: textColor,
        transition: 'all 0.5s ease-out',
        '&:hover': {
          background: light ? 'rgba(255,255,255,0.08)' : 'rgba(27, 31, 36, 0.08)',
        },
      }
    },
    singleValue: (baseStyles) => {
      return {
        ...baseStyles,
        color: color,
        fontFamily: 'halyard-display',
        fontWeight: '400',
        fontSize: '20px',
        lineHeight: '20px',
        textTransform: 'uppercase',
      }
    },
    dropdownIndicator: (baseStyles) => {
      return {
        ...baseStyles,
        color: color,
        '&:hover': {
          color: color,
        },
      }
    },
    indicatorSeparator: () => {
      return { display: 'none' }
    },
  }
}
